import Footer from "../../components/Footer/Footer";
import SplashScreen from "../../components/SplashScreen/SplashScreen";
import "./SplashPage.scss";

function SplashPage() {
  return (
    <div className="App d-flex flex-column min-vh-100">
      <SplashScreen />
      <Footer />
    </div>
  );
}

export default SplashPage;
